import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CLEAR_AUCTION_BET = 'AUCTION :: CLEAR_AUCTION_BET';

export type TClearAuctionBetAction = IReduxAction<typeof CLEAR_AUCTION_BET>;

export const clearAuctionBet = actionGenerator<typeof CLEAR_AUCTION_BET>(CLEAR_AUCTION_BET);
